import { withFallback } from './helpers/withFallback'

const defaultMqttStore = {
  connected: false,
}

const mqttState = {
  adapter: defaultMqttStore,
}

export function setXappCoreMqttAdapter(adapter) {
  mqttState.adapter = withFallback(adapter, defaultMqttStore)
}

export function useXappCoreMqttAdapter() {
  return mqttState.adapter
}
